"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var withCustomError_1 = __importDefault(require("../helpers/withCustomError"));
var maxLength = function (maxLengthValue) { return function (value) {
    if (value && value.length > 0) {
        return value.length > maxLengthValue
            ? "The input has more characters than " + maxLengthValue
            : undefined;
    }
    return undefined;
}; };
exports.default = (function (minValue, err) { return withCustomError_1.default(maxLength(minValue))(err); });
//# sourceMappingURL=maxLength.js.map